import { render, staticRenderFns } from "./Alert.vue?vue&type=template&id=39e1cd59&scoped=true&"
import script from "./Alert.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Alert.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./Alert.vue?vue&type=style&index=0&id=39e1cd59&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e1cd59",
  null
  
)

export default component.exports